import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import TranslationUtils from 'Utils/TranslationUtils';
import { Helmet } from 'react-helmet';
import EmailIcon from '../../../Assets/email.svg';
import c from '../../../Components/AuthLayout/authContent.module.less';
import styles from './EmailConfirm.module.less';
import { AppSelectors } from '../../../Redux/modules/app/selectors';
import { VettingActions } from '../../../Redux/modules/vetting/actions';

const EmailConfirmation = ({ confirmEmail, resendConfirmationEmail }) => {
  const resendEmail = () => {
    resendConfirmationEmail({ email: confirmEmail });
  };
  return (
    <>
      <Helmet>
        <title>{gettext('Confirm Email')}</title>
      </Helmet>
      <h1 className={c.title} test-id="page-title">
        {TranslationUtils.getText('EMAIL_CONFIRM_PAGE_TITLE')}
      </h1>
      <p className={c.text}>
        {TranslationUtils.getText('EMAIL_CONFIRM_PAGE_BODY_PART_ONE')}
        {TranslationUtils.getText('EMAIL_CONFIRM_PAGE_BODY_PART_TWO')} <span className={c.email}>{confirmEmail}</span>
      </p>

      <div className={styles.imageFooter}>
        <img src={EmailIcon} alt="" width="237" height="97" />
      </div>

      <p className={c.text}>
        {gettext("Didn't receive an email?")}{' '}
        <a onClick={() => resendEmail()} role="link" aria-label="Main" tabIndex="-1">
          {gettext('Click to resend')}
        </a>
      </p>
    </>
  );
};

EmailConfirmation.propTypes = {
  confirmEmail: PropTypes.string,
  resendConfirmationEmail: PropTypes.func,
};

const mapDispatchToProps = {
  resendConfirmationEmail: VettingActions.resendConfirmationEmail,
};

const mapStateToProps = (state) => {
  return {
    confirmEmail: AppSelectors.onBoardingConfirmEmailSelector(state),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailConfirmation);
